export interface Tab { id: string; label: string }

export function TabBar({ tabs, active, onChange }: { tabs: Tab[]; active: string; onChange: (id: string) => void }) {
  return (
    <div className="scroll-x border-b-2 border-ink !gap-6 !pb-0" role="tablist">
      {tabs.map((t) => {
        const on = t.id === active;
        return (
          <button key={t.id} id={`tab-${t.id}`} role="tab" aria-selected={on} onClick={() => onChange(t.id)}
            className={`-mb-[2px] shrink-0 whitespace-nowrap border-b-[3px] px-0.5 pb-2.5 pt-2 font-cond text-[16px] font-semibold uppercase tracking-[0.08em] transition-colors duration-100 ${on ? 'border-blue text-ink' : 'border-transparent text-muted hover:text-ink'}`}>
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
